import Button from '@mui/material/Button';
import { KPIVariant } from '@services/api/deckManagement/graphql/schema/API';

interface EditVariantCellRendererProps {
  data: KPIVariant;
  onEdit?: (variant: KPIVariant) => void;
}

/**
 * Cell renderer for the Edit action in the KPI Variant grid.
 * Calls onEdit with the variant data, stopping propagation to prevent row selection.
 */
const EditVariantCellRenderer = ({ data, onEdit }: EditVariantCellRendererProps) => {
  return (
    <Button
      variant='text'
      onClick={(event) => {
        event.stopPropagation();
        onEdit?.(data);
      }}
    >
      Edit
    </Button>
  );
};

export default EditVariantCellRenderer;
